import {
  UPDATE_RISK_LIST_SUCCESS,
  UPDATE_RISK_LIST_FAILED,
  RESET_UPDATE_RISK_LIST,
  LOADING_UPDATE_RISK_LIST,
  NETWORK_ERROR_UPDATE_RISK_LIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetUpdateRiskList = () => {
  return { type: RESET_UPDATE_RISK_LIST };
};

const getUpdateRiskList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_UPDATE_RISK_LIST });
  await partnerServices
    .post("updateRiskRule", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Success":
          dispatch(updateRiskListsuccess(res.data));
          break;
        default:
          dispatch(updateRiskListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_UPDATE_RISK_LIST, payload: err });
    });
};
function updateRiskListsuccess(data) {
  return {
    type: UPDATE_RISK_LIST_SUCCESS,
    payload: data,
  };
}
function updateRiskListFailed(data) {
  return {
    type: UPDATE_RISK_LIST_FAILED,
    payload: data,
  };
}

export { resetUpdateRiskList, getUpdateRiskList };
